import { ActivityReport, ActivityReportFilter } from '../shared/models';

export interface ActivityState {
  activityReport: ActivityReport,
  filter: ActivityReportFilter,
}

export interface State extends ActivityState {
  isLoading?: boolean;
  error?: any;
}

export const initialState: State = {
  activityReport: null,
  filter: null,
};

export const getActivityReport = (state: ActivityState) => state.activityReport;
export const getFilter = (state: ActivityState) => state.filter;
